export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      spAppMsts: [
        {
          spAppMstId: 1,
          spAppMstUuid: "spappmst001",
          serviceTermsFileName: "第一稿",
          serviceTermsFileUrl: "xxxxxx",
          serviceTermsFileContentsType: "xxxxxx",
          serviceTermsFileUpdatedAt: 1594880785395 
        }
      ]
    }
  }
}